import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';
import { mapDataForBackend } from './mapData';

export async function updateUserDetailsAPI(userDetails) {
  const url = `${AWS_API_URL}/my-details`;

  return postRequest(url, { data: mapDataForBackend(userDetails) }, await authorize());
}
